/**
 *
 */
export function getObject<T>(key: string): T | undefined {
  const objectJson = localStorage.getItem(key)
  return objectJson ? (JSON.parse(objectJson) as T) : undefined
}

/**
 *
 */
export function putObject<T>(key: string, object: T): void {
  localStorage.setItem(key, JSON.stringify(object))
}
